// 個別作業員のビルディ（Buildee）スクレイピング進捗ポーリング。
// グリーンサイトの worker_scrape_polling.js には手を加えず、ビルディ専用に新規実装。
// 取得ボタンクリック → スクレイプ要求 → 完了までポーリング → 結果表示・リロード。
function setupWorkerBuildeeScrapePolling(root) {
  root = root || document;
  var $ = window.jQuery;

  var btnEl = root.querySelector('.js-buildee-scrape-btn');
  if (!btnEl || !$ || !$.fn || !$.fn.toast) return;

  var statusUrl = btnEl.getAttribute('data-status-url');
  if (!statusUrl) return;

  var POLL_INTERVAL_MS = 3000;
  var MAX_POLL_ATTEMPTS = 100; // 約5分（3秒×100回）でタイムアウト
  var pollInterval = null;
  var pollInflight = false;
  var pollAttempts = 0;

  function stopPolling() {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
    pollInflight = false;
    pollAttempts = 0;
  }

  $(window).on('beforeunload pagehide', stopPolling);

  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  }

  function showToast(message, klass) {
    $('body').toast({
      message: message,
      class: klass || 'teal',
      showProgress: 'bottom'
    });
  }

  function startPolling(btn) {
    stopPolling();
    pollInterval = setInterval(function () {
      if (pollInflight) return;

      pollAttempts += 1;
      if (pollAttempts > MAX_POLL_ATTEMPTS) {
        stopPolling();
        btn.removeClass('loading disabled').prop('disabled', false);
        showToast('ビルディ取得がタイムアウトしました。後で再試行してください。', 'warning');
        return;
      }

      pollInflight = true;
      fetch(statusUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (resp) { return resp.json(); })
        .then(function (data) {
          pollInflight = false;
          if (data.status === 'success' || data.status === 'error') {
            stopPolling();
            btn.removeClass('loading disabled').prop('disabled', false);
            if (data.status === 'success') {
              showToast('ビルディ取得が完了しました。', 'teal');
            } else {
              showToast(data.error_message || 'ビルディ取得でエラーが発生しました', 'error');
            }
            setTimeout(function () { location.reload(); }, 1200);
          }
        })
        .catch(function () {
          pollInflight = false; // ネットワーク一時エラーは次回リトライ
        });
    }, POLL_INTERVAL_MS);
  }

  $(root).on('click', '.js-buildee-scrape-btn', function () {
    var btn = $(this);
    var workerName = btn.attr('data-worker-name') || '作業員';
    if (!confirm(workerName + 'のビルディ取得を実行しますか？')) return;

    btn.addClass('loading disabled').prop('disabled', true);

    fetch(btn.attr('data-url'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
        'Accept': 'application/json'
      },
      body: JSON.stringify({})
    })
      .then(function (resp) { return resp.json(); })
      .then(function (data) {
        if (data.ok) {
          showToast(data.message || 'ビルディ取得中...', 'blue');
          startPolling(btn);
        } else {
          btn.removeClass('loading disabled').prop('disabled', false);
          showToast(data.error || 'エラーが発生しました', 'error');
        }
      })
      .catch(function (err) {
        btn.removeClass('loading disabled').prop('disabled', false);
        showToast('リクエストに失敗しました: ' + err.message, 'error');
      });
  });
}

$(function () {
  setupWorkerBuildeeScrapePolling(document);
});
